import { ChevronRight } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import './EpiStatCard.scss';

interface Props {
	icon: ReactNode;
	color: string;
	value: string;
	label: string;
	detail?: string;
	chipLabel?: string;
	chipColor?: string;
	linkLabel?: string;
	onLinkClick?: () => void;
	variant?: 'value-first' | 'label-first';
}

const EpiStatCard: FC<Props> = ({ icon, color, value, label, detail, chipLabel, chipColor,
		linkLabel, onLinkClick, variant }) => (
	<div className="epi-stat-card">
		<div className="conteudo">
			<span className="icone" style={{ backgroundColor: color }}>{icon}</span>
			<div className={variant === 'label-first' ? 'texto rotulo-primeiro' : 'texto'}>
				{variant === 'label-first'
					? <>
						<span className="rotulo">{label}</span>
						<Typography variant="h5" style={{ color: color }}>{value}</Typography>
					</>
					: <>
						<Typography variant="h4" style={{ color: color }}>{value}</Typography>
						<span className="rotulo">{label}</span>
					</>
				}
				{!!detail && <span className="detalhe">{detail}</span>}
				{!!chipLabel && (
					<span className="chip" style={{ backgroundColor: chipColor || color }}>
						{chipLabel}
					</span>
				)}
			</div>
		</div>
		{!!linkLabel && (
			<div className="rodape" style={{ color: color }} onClick={onLinkClick}>
				{linkLabel} <ChevronRight fontSize="small" />
			</div>
		)}
	</div>
);

export default EpiStatCard;
